import areaCodeCN from '../assets/json/areaCodeCN.json'
import areaCodeEn from '../assets/json/areaCodeEn.json'

export type LoginCountry = {
  code: string
  countryCode: string
  twoCharCode: string
  name: string
  flag: string
  [key: string]: any
}

type CountryGroup = {
  name: string
  data: LoginCountry[]
}

const ZH_LOCALES = new Set(['zh', 'zh-cn', 'zh-hk', 'zh-tw'])
const CN_LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'J',
  'K',
  'L',
  'M',
  'N',
  'P',
  'R',
  'S',
  'T',
  'W',
  'X',
  'Y',
  'Z',
]
const EN_LETTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'Y',
  'Z',
]

const COUNTRY_GROUPS_CN = areaCodeCN as CountryGroup[]
const COUNTRY_GROUPS_EN = areaCodeEn as CountryGroup[]

export const useLoginCountries = () => {
  const appStore = useAppStore()
  const { locale } = useAppI18n()

  const isChineseLocale = computed(() => ZH_LOCALES.has(locale))
  const countries = computed(() => (isChineseLocale.value ? COUNTRY_GROUPS_CN : COUNTRY_GROUPS_EN))
  const letters = computed(() => (isChineseLocale.value ? CN_LETTERS : EN_LETTERS))
  const flatCountries = computed(() => countries.value.flatMap((group) => group.data || []))

  const ensureSelectedCountry = () => {
    if (appStore.usergetCountry?.code) {
      return appStore.usergetCountry as LoginCountry
    }

    const targetCode = (appStore.myCountry || appStore.CountryCode || '156').toUpperCase()
    const match =
      flatCountries.value.find((item) => item.twoCharCode === targetCode) ||
      flatCountries.value.find((item) => item.countryCode === targetCode) ||
      flatCountries.value.find((item) => item.twoCharCode === 'CN') ||
      flatCountries.value[0]

    if (match) {
      appStore.setuserCountry(match)
      return match
    }

    return null
  }

  const syncSelectedCountry = (twoCharCode: string) => {
    const normalizedCode = twoCharCode.toUpperCase()
    const match =
      flatCountries.value.find((item) => item.twoCharCode === normalizedCode) ||
      flatCountries.value.find((item) => item.code === normalizedCode)

    if (match) {
      appStore.setuserCountry(match)
      return match
    }

    return ensureSelectedCountry()
  }

  return {
    countries,
    letters,
    flatCountries,
    isChineseLocale,
    ensureSelectedCountry,
    syncSelectedCountry,
  }
}
